export default "__VITE_ASSET__3d37XgPi__"